import PropTypes from 'prop-types';
import Cover from './Cover';
import css from './Cover.scss';

const classes = {
	root: css.cover,
	figure: css.coverFigure,
	header: css.coverHeader,
	headerTitle: css.coverHeaderTitle,
	headerSubtitle: css.coverHeaderSubtitle,
};

const propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	onLoadStart: PropTypes.func,
	onLoadError: PropTypes.func,
	onLoadProgress: PropTypes.func,
	onLoadComplete: PropTypes.func,
	mobile: PropTypes.bool,
	noiseWidth: PropTypes.number,
	smoothMask: PropTypes.number,
	progress: PropTypes.number,
	assets: PropTypes.arrayOf(PropTypes.shape({
		name: PropTypes.string,
		text: PropTypes.string,
		label: PropTypes.string,
		src: PropTypes.string,
	})),
};

const defaultProps = {
	className: '',
	classes,
	onLoadStart: Function.prototype,
	onLoadError: Function.prototype,
	onLoadProgress: Function.prototype,
	onLoadComplete: Function.prototype,
	mobile: false,
	noiseWidth: 0,
	smoothMask: 0,
	progress: 0.5,
	assets: [],
};

Cover.displayName = 'Cover';
Cover.propTypes = propTypes;
Cover.defaultProps = defaultProps;
export { Cover };
export default Cover;
